import React, { Component } from 'react';

import IssueInformation from 'components/IssueInformation';

import { ISSUE_REFUND_STATUS } from '../../../config/constants';


class IssueDetails extends Component {
  render() {
    return (
      <div>
        <IssueInformation issue={this.props.issue} appointment={this.props.appointment} />

        <div className="mt-2">
          <div>
            <strong>Issue Survey:</strong>
          </div>
          <div className="mt-1">
            {this.props.issue.issueAnswers.map(issueAnswer => (
              <div key={issueAnswer.id}>
                <div>
                  <u>{issueAnswer.issueQuestion.question}</u>
                </div>
                <div className="mt-1">{issueAnswer.answer}</div>
              </div>
            ))}
          </div>
        </div>

        {this.props.issue.issueDispute && (
          <div>
            <div className="mt-4">
              <div>
                <strong>Teacher Dispute:</strong>
              </div>
              <div>{this.props.issue.issueDispute.reason}</div>
            </div>

            {this.props.issue.refundStatus === ISSUE_REFUND_STATUS.DISPUTED_BY_TEACHER && (
              <div>
                <div className="mt-4">
                  Please describe the resolution for both the student and teacher
                  <textarea
                    value={this.props.resolutionDescription}
                    className="form-control"
                    rows="6"
                    placeholder=""
                    onChange={this.props.handleResolutionChange}
                  />
                </div>
                <div className="d-flex justify-content-between mt-4">
                  <button
                    className="btn btn-primary btn-success"
                    type="button"
                    onClick={() => this.props.approve(this.props.issue.id)}
                    disabled={this.props.isSubmitDisabled()}
                  >
                    Approve Refund
                  </button>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => this.props.deny(this.props.issue.id)}
                    disabled={this.props.isSubmitDisabled()}
                  >
                    Deny Refund
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default IssueDetails;



// WEBPACK FOOTER //
// ./src/pages/admin/IssueDetails/index.js